export const theme = {
  colors: {
    // Primary: dominant white
    white: '#FFFFFF',
    offWhite: '#FAFAF7',
    background: '#FFFFFF',
    surface: '#FFFFFF',
    surfaceAlt: '#F7F7F4',

    // Secondary: gold accents
    gold: '#C8A951',
    goldLight: '#E6C96A',
    goldDark: '#9C8033',
    goldSoft: '#F4EAD0',

    // Tertiary: black / near-black for depth
    black: '#000000',
    nearBlack: '#111111',
    charcoal: '#1E1E1E',

    // Text
    textPrimary: '#1A1A1A',
    textMuted: '#555555',
    textSubtle: '#8A8A8A',

    // UI support
    border: '#E9E9E6',
    borderStrong: '#CFCFCA',
    danger: '#C0392B',
    success: '#2E7D32',

    // Convenience aliases used by some shared styles
    primary: '#FFFFFF',
    secondary: '#C8A951',
    tertiary: '#000000',
    text: '#1A1A1A',
    lightText: '#555555',
    gray: '#E9E9E6',
    darkGray: '#8A8A8A',
  },
  fonts: {
    heading: "'Playfair Display', 'Cormorant Garamond', Georgia, serif",
    body: "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    main: "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.375rem',
    '2xl': '1.75rem',
    '3xl': '2.25rem',
    '4xl': '3rem',
    '5xl': '4rem',
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900,
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    large: '1200px',
  },
  shadows: {
    card: '0 2px 10px rgba(0, 0, 0, 0.06)',
    cardHover: '0 12px 28px rgba(0, 0, 0, 0.10)',
    feature: '0 20px 40px rgba(0, 0, 0, 0.12)',
    goldGlow: '0 6px 22px rgba(200, 169, 81, 0.35)',
  },
  radii: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    pill: '999px',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2.5rem',
    '2xl': '4rem',
    '3xl': '6rem',
  },
  transitions: {
    base: 'all 0.25s ease',
    slow: 'all 0.4s ease',
  },
};
